export default "__VITE_ASSET__BvUiH9po__"